module.exports = __webpack_public_path__ + "media/images/area-badges/ocean-stewardship-57282dd87ac0ecfde782fa46818b99b8.svg";